<template>
  <v-card>
    <v-layout
      row
      ma-0
      pa-8
      py-12
      justify-center
      align-center
      class="group"
    >
      <v-icon class="drag-icon" size="18">icon-drag</v-icon>
      <IDCard
        :title="$t('dashboard-screen.firmID-nofirm')"
        style="width: 55%;"
        noEdit
      ></IDCard>

      <v-spacer></v-spacer>
      <v-divider vertical></v-divider>
      <v-spacer></v-spacer>

      <div class="text-center">
        <h3 class="mb-3">Status</h3>
        <ProgressGauge status="oops"></ProgressGauge>
      </div>

      <v-spacer></v-spacer>
      <v-divider vertical></v-divider>
      <v-spacer></v-spacer>

      <v-layout
        ma-0
        justify-center
        align-center
      >
        <v-btn
          color="primary"
          elevation="0"
          rounded
          small
          class="fetch"
          to="/profile"
        >
          {{ $t('dashboard-screen.btn-2') }}
        </v-btn>
      </v-layout>
    </v-layout>

  </v-card>
</template>

<script>
import IDCard from '@/components/firm/IDCard'
import ProgressGauge from '@/components/progress/ProgressGauge'

export default {
  components: {
    IDCard: IDCard,
    ProgressGauge: ProgressGauge
  }
}
/* eslint-disable */
</script>

<style lang="scss" scoped>
@import '../../styles/components/audits/group-overview';

</style>
